<template>
  <div>
    <header class="header transparent">
      <div class="main-bar">
        <div class="container">
          <div class="header-content">
            <div class="left-content">
              <a @click="$previous()" class="back-btn">
                <svg width="18" height="18" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.03033 0.46967C9.2966 0.735936 9.3208 1.1526 9.10295 1.44621L9.03033 1.53033L2.561 8L9.03033 14.4697C9.2966 14.7359 9.3208 15.1526 9.10295 15.4462L9.03033 15.5303C8.76406 15.7966 8.3474 15.8208 8.05379 15.6029L7.96967 15.5303L0.96967 8.53033C0.703403 8.26406 0.679197 7.8474 0.897052 7.55379L0.96967 7.46967L7.96967 0.46967C8.26256 0.176777 8.73744 0.176777 9.03033 0.46967Z" fill="#2da333"/>
                </svg>
              </a>
              <h5 class="mb-0 ms-2 text-nowrap">Parolier</h5>
            </div>
            <div class="mid-content">
            </div>
            <div class="right-content">
            </div>
          </div>
        </div>
      </div>
    </header>


    <!-- Page Content -->
    <div class="page-content">
      <div class="content-body">

        <div class="dz-banner-heading position-relative">
          <div class="overlay-black-light style-2">
            <img src="../../../assets/MUSIQUE.png" class="bnr-img" alt="">
          </div>
          <div class="banner-content">
            <div class="container">
              <h4 class="mb-1 text-white">{{ musique?.title }}</h4>
              <p class="address mb-2">
                <i class="fa-solid fa-music me-2"></i>
                {{ musique?.author }}
              </p>
            </div>
          </div>
        </div>

        <div class="featured-box bg-white account-box">
          <div class="container">
            <div class="title-bar mt-0">
              <h5 class="title">Paroles</h5>
              <a href="javascript:void(0);">
                <i class="fa-solid fa-angle-right"></i>
              </a>
            </div>
            <div class="row g-3">
              <div class="lyric" v-for="(word,index) in musique?.lyrics" :key="{index}">
                <p class="mb-1 text-start font-14" style="font-weight: bold">[{{word.ref ? 'Choeur' : 'Lead'}}]</p>
                <p class="text-justify" >{{word.text}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br> <br> <br> <br>
    </div>

  </div>
</template>

<script setup>
import {computed} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {usePrevious} from "@/composables/usePrevious";
import TopBar from "@/views/master/layouts/partials/TopBar";

const store = useStore()
const route = useRoute()
const {$previous} = usePrevious()

const musiques = computed(() => store.getters['musique/musiques'])
const musique = computed(() => {
    return musiques.value.filter(musique => musique.id == route.params.id)[0]
})

</script>
<style>
.italic{
  font-style: italic;
}
</style>